import {
  useFireRiskProcessStore,
  useFireRiskSubProcessStore,
  useHazardousMaterialRiskProcessStore,
  useHazardousMaterialRiskSubProcessStore,
} from "../store/store";
import { OrgUserType } from "../types/api";

export const whrDataFormate = (
  premiseUsers: OrgUserType[],
  moduleName?: string
) => {
  let processData: any[] = [];
  let subProcessData: any[] = [];

  if (
    moduleName === "hazardous-materials" ||
    moduleName === "hazardousMaterials"
  ) {
    const { hazardousMaterialRiskProcessessData } =
      useHazardousMaterialRiskProcessStore.getState();
    const { hazardousMaterialRiskSubProcessData } =
      useHazardousMaterialRiskSubProcessStore.getState();
    processData = hazardousMaterialRiskProcessessData;
    subProcessData = hazardousMaterialRiskSubProcessData;
  } else {
    // Default to fire system
    const { fireRiskProcessessData } = useFireRiskProcessStore.getState();
    const { fireRiskSubProcessData } = useFireRiskSubProcessStore.getState();
    processData = fireRiskProcessessData;
    subProcessData = fireRiskSubProcessData;
  }
  return {
    header: [
      {
        title: "all",
        colnumber: 2,
      },
      {
        title: "Initial Actual Risk",
        colnumber: 7,
      },
      {
        title: "Recalculation of risk scores",
        colnumber: 6,
      },
      {
        title: "all",
        colnumber: 4,
      },
    ],
    columns: [
      {
        title: "Process",
        type: "dropdown",
        columnName: "process",
        options: processData,
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Sub Process",
        type: "dropdown",
        columnName: "subProcesses",
        options: subProcessData,
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Objective",
        type: "text",
        columnName: "objective",

        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Probability of failure",
        type: "number",
        columnName: "initialActualRisk.ProbabilityOfFailure",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },

      {
        title: "Severity of outcome",
        type: "number",
        columnName: "initialActualRisk.SeverityOfOutCome",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Ability to detect failure",
        type: "number",
        columnName: "initialActualRisk.AbilityToDetectFailure",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Total risk score",
        type: "number",
        columnName: "initialActualRisk.TotalRiskScore",
        classnames: "text-center  block m-auto w-11/12 rounded",
        isDisabled: true,
      },
      {
        title: "Solution implemented",
        type: "dropdown",
        options: ["Yes fully", "Partially", "Not Implemented"],
        columnName: "recalculationOfRisk.SolutionImplemented",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Next steps on sustenance",
        type: "textbox",
        columnName: "recalculationOfRisk.nextStepOnSustenance",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Probability of failure",
        type: "number",
        columnName: "recalculationOfRisk.ProbabilityOfFailure",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Severity of outcome",
        type: "number",
        columnName: "recalculationOfRisk.SeverityOfOutCome",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Ability to detect failure",
        type: "number",
        columnName: "recalculationOfRisk.AbilityToDetectFailure",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Total risk score",
        type: "number",
        columnName: "recalculationOfRisk.TotalRiskScore",
        classnames: "text-center  block m-auto w-11/12 rounded",
        isDisabled: true,
      },
      {
        title: "Responsible individual to implement",
        type: "multiselect",
        options: premiseUsers,
        // .map((user: OrgUserType) => ({
        //   label: `${user.firstName} ${user.lastName}`,
        //   value: typeof user._id === "object" && "$oid" in user._id
        //     ? user._id.$oid
        //     : String(user._id),
        // })),

        columnName: "responsibilityIndividual",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Possible failure risk",
        type: "text",
        columnName: "possibleFailureRisk",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Action/ solutions to mitigate the risk",
        type: "textbox",
        columnName: "actionsSolution",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Monitoring procedure",
        type: "text",
        columnName: "monitoringProcedure",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Timeline to implement (Days)",
        type: "date",
        columnName: "TimeLineToImplement",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Remarks",
        type: "text",
        columnName: "remarks",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
    ],
    emptyObject: {
      // id: "",
      process: "",
      subProcesses: "",
      objective: "",
      responsibilityIndividual: [],
      possibleFailureRisk: "",
      actionsSolution: "",
      TimeLineToImplement: "",
      monitoringProcedure: "",
      remarks: "",
      initialActualRisk: {
        ProbabilityOfFailure: "",
        SeverityOfOutCome: "",
        AbilityToDetectFailure: "",
        TotalRiskScore: "",
      },
      recalculationOfRisk: {
        SolutionImplemented: "",
        nextStepOnSustenance: "",
        ProbabilityOfFailure: "",
        SeverityOfOutCome: "",
        AbilityToDetectFailure: "",
        TotalRiskScore: "",
      },
      assessment: "",
    },
  };
};

export const ahrDataFormate = (
  premiseUsers: OrgUserType[],
  moduleName?: string
) => {
  let processData: any[] = [];
  let subProcessData: any[] = [];

  if (
    moduleName === "hazardous-materials" ||
    moduleName === "hazardousMaterials"
  ) {
    const { hazardousMaterialRiskProcessessData } =
      useHazardousMaterialRiskProcessStore.getState();
    const { hazardousMaterialRiskSubProcessData } =
      useHazardousMaterialRiskSubProcessStore.getState();
    processData = hazardousMaterialRiskProcessessData;
    subProcessData = hazardousMaterialRiskSubProcessData;
  } else {
    // Default to fire system
    const { fireRiskProcessessData } = useFireRiskProcessStore.getState();
    const { fireRiskSubProcessData } = useFireRiskSubProcessStore.getState();
    processData = fireRiskProcessessData;
    subProcessData = fireRiskSubProcessData;
  }
  return {
    header: [
      {
        title: "all",
        colnumber: 2,
      },
      {
        title: "Initial Actual Risk",
        colnumber: 7,
      },
      {
        title: "Recalculation of risk scores",
        colnumber: 6,
      },
      {
        title: "all",
        colnumber: 4,
      },
    ],
    columns: [
      {
        title: "Process",
        type: "dropdown",
        columnName: "process",
        options: processData,
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Sub Process",
        type: "dropdown",
        columnName: "subProcesses",
        options: subProcessData,
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Objective",
        type: "text",
        columnName: "objective",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Probability of failure",
        type: "number",
        columnName: "initialActualRisk.ProbabilityOfFailure",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Severity of outcome",
        type: "number",
        columnName: "initialActualRisk.SeverityOfOutCome",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Ability to detect failure",
        type: "number",
        columnName: "initialActualRisk.AbilityToDetectFailure",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Total risk score",
        type: "number",
        columnName: "initialActualRisk.TotalRiskScore",
        classnames: "text-center  block m-auto w-11/12 rounded",
        isDisabled: true,
      },
      {
        title: "Solution implemented",
        type: "dropdown",
        options: ["Yes fully", "Partially", "Not Implemented"],
        columnName: "recalculationOfRisk.SolutionImplemented",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Next steps on sustenance",
        type: "textbox",
        columnName: "recalculationOfRisk.nextStepOnSustenance",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Probability of failure",
        type: "number",
        columnName: "recalculationOfRisk.ProbabilityOfFailure",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Severity of outcome",
        type: "number",
        columnName: "recalculationOfRisk.SeverityOfOutCome",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Ability to detect failure",
        type: "number",
        columnName: "recalculationOfRisk.AbilityToDetectFailure",
        classnames: "text-center  block m-auto w-11/12 rounded",
      },
      {
        title: "Total risk score",
        type: "number",
        columnName: "recalculationOfRisk.TotalRiskScore",
        classnames: "text-center  block m-auto w-11/12 rounded",
        isDisabled: true,
      },
      {
        title: "Responsible individual to implement",
        type: "multiselect",
        options: premiseUsers,
        columnName: "responsibilityIndividual",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Possible failure risk",
        type: "text",
        columnName: "possibleFailureRisk",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Action/ solutions to mitigate the risk",
        type: "textbox",
        columnName: "actionsSolution",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Monitoring procedure",
        type: "text",
        columnName: "monitoringProcedure",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Timeline to implement (Days)",
        type: "date",
        columnName: "TimeLineToImplement",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
      {
        title: "Remarks",
        type: "text",
        columnName: "remarks",
        classnames: "text-center bg-white  block m-auto w-11/12 rounded",
      },
    ],
    emptyObject: {
      // id: "",
      process: "",
      subProcesses: "",
      objective: "",
      possibleFailureRisk: "",
      initialActualRisk: {
        ProbabilityOfFailure: "",
        SeverityOfOutCome: "",
        AbilityToDetectFailure: "",
        TotalRiskScore: "",
      },
      actionsSolution: "",
      responsibilityIndividual: [],
      TimeLineToImplement: "",
      monitoringProcedure: "",
      remarks: "",
      recalculationOfRisk: {
        SolutionImplemented: "",
        nextStepOnSustenance: "",
        ProbabilityOfFailure: "",
        SeverityOfOutCome: "",
        AbilityToDetectFailure: "",
        TotalRiskScore: "",
      },
      assessment: "",
    },
  };
};
